<template>
  <div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th v-for="col in columns" :key="col.field">{{ col.label }}</th>
        </tr>
      </thead>
      <tbody>
           <tr
            v-for="item in paginatedData"
            :key="item.uuid"
            @click="$emit('linhaSelecionada', item)"
            style="cursor: pointer;"
            >
            <td v-for="col in columns" :key="col.field">{{ item[col.field] }}</td>
            </tr>
        </tbody>
    </table>

    <!-- Paginação -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <button class="btn btn-sm btn-outline-primary" @click="prevPage" :disabled="currentPage === 1">
        ← Anterior
      </button>
      <span>Página {{ currentPage }} de {{ totalPages }}</span>
      <button class="btn btn-sm btn-outline-primary" @click="nextPage" :disabled="currentPage >= totalPages">
        Próxima →
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.data.length / this.perPage);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.data.slice(start, start + this.perPage);
    },
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
  },
};
</script>

<style scoped>
.table {
  width: 100%;
}
</style>